import { Heading, Stack, Text } from '../../ui';
import { landingCopy } from './copy';

/**
 * A three-step "how it works" walkthrough, from sign-up to finding events.
 *
 * @returns The how-it-works section.
 */
export function HowItWorks(): React.JSX.Element {
  return (
    <section className="gm-landing__section" aria-labelledby="gm-landing-how">
      <div className="gm-landing__section-head">
        <h2 id="gm-landing-how" className="gm-landing__section-title">
          How it works
        </h2>
      </div>

      <ol className="gm-landing__steps">
        {landingCopy.steps.map((step, index) => (
          <li key={step.title} className="gm-landing__step">
            <span className="gm-landing__step-number" aria-hidden={true}>
              {index + 1}
            </span>
            <Stack gap="xs">
              <Heading level={3}>{step.title}</Heading>
              <Text muted>{step.body}</Text>
            </Stack>
          </li>
        ))}
      </ol>
    </section>
  );
}
